import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { hideReprocessingModal } from '../../actions';

class ReprocessingModal extends Component {
    render() {
        const {show, hideReprocessingModal, text} = this.props;
        return (
            <Modal show={show} onHide={hideReprocessingModal}>
                <Modal.Header closeButton>
                    <Modal.Title> Reprocessing Submitted </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className='reprocessing'>
                        {text}
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    hideReprocessingModal
};

const mapStateToProps = state => ({
    show: state.ui.reprocessing.show,
    text: state.ui.reprocessing.text
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReprocessingModal);

ReprocessingModal.propTypes = {
    show:                  PropTypes.bool.isRequired,
    hideReprocessingModal: PropTypes.func.isRequired,
    text:                  PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/reprocessingModal/ReprocessingModal.js